import React from 'react';
import { EditFormData } from '../types';
import { transformFormDataToApi, formatRuleDisplay } from '../utils';

interface LivePreviewProps {
  formData: EditFormData;
}

const LivePreview: React.FC<LivePreviewProps> = ({ formData }) => {
  // Generate preview by transforming form data to API format and then displaying it
  const generatePreview = () => {
    try {
      // Transform form data to API rule format
      const apiRule = transformFormDataToApi(formData);

      // Generate the formatted display
      const formattedDisplay = formatRuleDisplay(apiRule);

      return formattedDisplay;
    } catch (error) {
      return 'Invalid configuration';
    }
  };

  const preview = generatePreview();

  return (
    <div
      style={{
        backgroundColor: '#f9f9f9',
        border: '1px solid #e6e6e6',
        borderRadius: 8,
        padding: '16px',
        marginLeft: '16px',
        minWidth: '300px',
        maxWidth: '400px',
        height: 'fit-content',
        position: 'sticky',
        top: '16px',
      }}
    >
      <div
        style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#262626',
          marginBottom: '12px',
          borderBottom: '1px solid #e6e6e6',
          paddingBottom: '8px',
        }}
      >
        Preview
      </div>

      <div
        style={{
          fontSize: '14px',
          fontWeight: '500',
          fontFamily: 'monospace',
          color: '#495057',
          lineHeight: '1.5',
          wordBreak: 'break-word',
          minHeight: '24px',
          padding: '8px 0',
        }}
        dangerouslySetInnerHTML={{ __html: preview }}
        data-test-id="live-preview-html"
      />
    </div>
  );
};

export default LivePreview;
